import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from "react";
import { useStaticQuery } from "gatsby";
import UserNavBar from "../UserComponents/NavBar";
import { withPathPrefix } from "../../utils";

function loadRbacNavItems(_x, _x2) {
  return _loadRbacNavItems.apply(this, arguments);
}

function _loadRbacNavItems() {
  _loadRbacNavItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(a, b) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(withPathPrefix("_auth/header", b));

          case 3:
            return _context2.abrupt("return", _context2.sent.json());

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", a);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _loadRbacNavItems.apply(this, arguments);
}

export function NavBar(a) {
  var _useStaticQuery = useStaticQuery("561138138"),
      b = _useStaticQuery.siteConfig,
      c = _useStaticQuery.site.pathPrefix;

  var d = b.nav,
      e = b.withRbac,
      _b$logo = b.logo,
      f = _b$logo.href,
      g = _b$logo.altText,
      h = _b$logo.image,
      _React$useState = React.useState(d),
      i = _React$useState[0],
      j = _React$useState[1];

  return React.useEffect(function () {
    e && _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = "development" === process.env.NODE_ENV;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t1 = j;
              _context.next = 5;
              return loadRbacNavItems(i, c);

            case 5:
              _context.t2 = _context.sent;
              (0, _context.t1)(_context.t2);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [e]), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserNavBar, Object.assign({
    items: i,
    logo: h,
    altText: g,
    href: f,
    pathPrefix: c,
    sidebarName: a.sidebarName
  }, a)));
}